Services.Enums = function Enums() {

    var mapEnumArrayToObject = function (arr, newKey, keyForValue) {
        var ret = {};
        arr.forEach(function (item) {
            if (item[newKey]) {
                if (keyForValue) {
                    ret[item[newKey]] = item[keyForValue];
                } else {
                    ret[item[newKey]] = item;
                }
            }
        });
        return ret;
    };

    var ExtendedCreativeTypes = [
        /* From company types */
        {key: 'event_planner', translationEntry: 'EXTENDED_CREATIVE_TYPES._EVENT_PLANNER_', supported: true},
        {key: 'venue', translationEntry: 'EXTENDED_CREATIVE_TYPES._VENUE_', supported: true},
        {key: 'photographer', translationEntry: 'EXTENDED_CREATIVE_TYPES._PHOTOGRAPHER_', supported: true},
        {key: 'rental', translationEntry: 'EXTENDED_CREATIVE_TYPES._RENTAL_', supported: true},
        {key: 'florist', translationEntry: 'EXTENDED_CREATIVE_TYPES._FLORIST_', supported: true},
        {key: 'stationery', translationEntry: 'EXTENDED_CREATIVE_TYPES._STATIONERY_', supported: true},
        {key: 'other', translationEntry: 'EXTENDED_CREATIVE_TYPES._OTHER_', supported: true},
        {key: 'fashion', translationEntry: 'EXTENDED_CREATIVE_TYPES._FASHION_', supported: true},
        {key: 'photo_booth', translationEntry: 'EXTENDED_CREATIVE_TYPES._PHOTO_BOOTH_', supported: true},
        {key: 'cinematography', translationEntry: 'EXTENDED_CREATIVE_TYPES._CINEMATOGRAPHY_', supported: true},
        {key: 'event_lighting', translationEntry: 'EXTENDED_CREATIVE_TYPES._EVENT_LIGHTING_', supported: true},
        {key: 'officiant', translationEntry: 'EXTENDED_CREATIVE_TYPES._OFFICIANT_', supported: true},
        {key: 'marketing', translationEntry: 'EXTENDED_CREATIVE_TYPES._MARKETING_', supported: true},
        {key: 'visual_artist', translationEntry: 'EXTENDED_CREATIVE_TYPES._VISUAL_ARTIST_', supported: true},
        {key: 'blogger', translationEntry: 'EXTENDED_CREATIVE_TYPES._BLOGGER_', supported: true},
        {key: 'business_consultant', translationEntry: 'EXTENDED_CREATIVE_TYPES._BUSINESS_CONSULTANT_', supported: true},
        {key: 'calligrapher', translationEntry: 'EXTENDED_CREATIVE_TYPES._CALLIGRAPHER_', supported: true},
        {key: 'interior_designer', translationEntry: 'EXTENDED_CREATIVE_TYPES._INTERIOR_DESIGNER_', supported: true},
        {key: 'graphic_designer', translationEntry: 'EXTENDED_CREATIVE_TYPES._GRAPHIC_DESIGNER_', supported: true},
        {key: 'maker_artisan', translationEntry: 'EXTENDED_CREATIVE_TYPES._MAKER_ARTISAN_', supported: true},
        {key: 'web_designer', translationEntry: 'EXTENDED_CREATIVE_TYPES._WEB_DESIGNER_', supported: true},

        /* Modified company types */
        {key: 'musician', translationEntry: 'EXTENDED_CREATIVE_TYPES._MUSICIAN_', supported: true},
        {key: 'hair_design', translationEntry: 'EXTENDED_CREATIVE_TYPES._HAIR_DESIGN_', supported: true},
        {key: 'makeup_artist', translationEntry: 'EXTENDED_CREATIVE_TYPES._MAKEUP_ARTIST_', supported: true},
        {key: 'entertainment', translationEntry: 'EXTENDED_CREATIVE_TYPES._ENTERTAINMENT_', supported: true},
        {key: 'dj', translationEntry: 'EXTENDED_CREATIVE_TYPES._DJ_', supported: true},
        {key: 'bar_services', translationEntry: 'EXTENDED_CREATIVE_TYPES._BAR_SERVICES_', supported: true},
        {key: 'catering', translationEntry: 'EXTENDED_CREATIVE_TYPES._CATERING_', supported: true},
        {key: 'bakery', translationEntry: 'EXTENDED_CREATIVE_TYPES._BAKERY_', supported: true},
        {key: 'desserts', translationEntry: 'EXTENDED_CREATIVE_TYPES._DESSERTS_', supported: true},

        /* New types */
        {key: 'fireworks', translationEntry: 'EXTENDED_CREATIVE_TYPES._FIREWORKS_', supported: true},
        {key: 'architecture', translationEntry: 'EXTENDED_CREATIVE_TYPES._ARCHITECTURE_', supported: true},
        {key: 'attire_rentals', translationEntry: 'EXTENDED_CREATIVE_TYPES._ATTIRE_RENTALS_', supported: true},
        {key: 'author_writer', translationEntry: 'EXTENDED_CREATIVE_TYPES._AUTHOR_WRITER_', supported: true},
        {key: 'copywriter', translationEntry: 'EXTENDED_CREATIVE_TYPES._COPYWRITER_', supported: true},
        {key: 'crafting', translationEntry: 'EXTENDED_CREATIVE_TYPES._CRAFTING_', supported: true},
        {key: 'ceramics', translationEntry: 'EXTENDED_CREATIVE_TYPES._CERAMICS_', supported: true},
        {key: 'branding', translationEntry: 'EXTENDED_CREATIVE_TYPES._BRANDING_', supported: true},
        {key: 'hand_lettering', translationEntry: 'EXTENDED_CREATIVE_TYPES._HAND_LETTERING_', supported: true},
        {key: 'fiber_art', translationEntry: 'EXTENDED_CREATIVE_TYPES._FIBER_ART_', supported: true},
        {key: 'jewelry', translationEntry: 'EXTENDED_CREATIVE_TYPES._JEWELRY_', supported: true},
        {key: 'merchandiser', translationEntry: 'EXTENDED_CREATIVE_TYPES._MERCHANDISER_', supported: true},
        {key: 'photo_editing', translationEntry: 'EXTENDED_CREATIVE_TYPES._PHOTO_EDITING_', supported: true},
        {key: 'product_designer', translationEntry: 'EXTENDED_CREATIVE_TYPES._PRODUCT_DESIGNER_', supported: true},
        {key: 'publishing', translationEntry: 'EXTENDED_CREATIVE_TYPES._PUBLISHING_', supported: true},
        {key: 'styling', translationEntry: 'EXTENDED_CREATIVE_TYPES._STYLING_', supported: true},
        {key: 'strategy', translationEntry: 'EXTENDED_CREATIVE_TYPES._STRATEGY_', supported: true},
        {key: 'virtual_assistant', translationEntry: 'EXTENDED_CREATIVE_TYPES._VIRTUAL_ASSISTANT_', supported: true},
        {key: 'web_developer', translationEntry: 'EXTENDED_CREATIVE_TYPES._WEB_DEVELOPER_', supported: true},
        {key: 'illustration', translationEntry: 'EXTENDED_CREATIVE_TYPES._ILLUSTRATION_', supported: true},
        {key: 'transportation', translationEntry: 'EXTENDED_CREATIVE_TYPES._TRANSPORTATION_', supported: true},

        /* Unsupported types - non used company types*/
        {key: 'cake', translationEntry: 'EXTENDED_CREATIVE_TYPES._CAKE_', supported: false},
        {key: 'hair_makeup', translationEntry: 'EXTENDED_CREATIVE_TYPES._HAIR_MAKEUP_', supported: false},
        {key: 'dj_musician', translationEntry: 'EXTENDED_CREATIVE_TYPES._DJ_MUSICIAN_', supported: false},
        {key: 'caterer', translationEntry: 'EXTENDED_CREATIVE_TYPES._CATERER_', supported: false},
    ];

    var ExtendedCreativeTypesPlural = { //removing those that dont make sense to the sentence.
        'event_planner': 'Event Planners',
            'venue': 'Venues',
            'photographer': 'Photographers',
            'rental': 'Rental Businesses',
            'florist': 'Florists',
            'fashion': 'Fashion Designers',
            'photo_booth': 'Photo Booths',
            'cinematography': 'Videographers',
            'officiant': 'Officiants',
            'visual_artist': 'Visual Artists',
            'blogger': 'Bloggers',
            'business_consultant': 'Business Consultants',
            'calligrapher': 'Calligraphers',
            'interior_designer': 'Interior Designers',
            'graphic_designer': 'Graphic Designers',
            'maker_artisan': 'Makers',
            'web_designer': 'Web Designers',
            'musician': 'Musicians',
            'hair_design': 'Hair Designers',
            'makeup_artist': 'Makeup Artists',
            'dj': 'DJs',
            'bar_services': 'Bar Services',
            'catering': 'Caterers',
            'bakery': 'Bakers',
            'architecture': 'Architects',
            'author_writer': 'Writers',
            'copywriter': 'Copywriters',
            'jewelry': 'Jewelers',
            'merchandiser': 'Boutique Owners',
            'photo_editing': 'Photo Editors',
            'product_designer': 'Product Designers',
            'publishing': 'Publishers',
            'styling': 'Stylists',
            'strategy': 'Strategists',
            'virtual_assistant': 'Virtual Assistants',
            'web_developer': 'Web Developers',
            'illustration': 'Illustrators',
            'dj_musician': 'DJs',
            'caterer': 'Caterers',
            'other': 'Small Businesses'
    };

    return {
        WorkspaceFileTypes: {
            proposal: 0,
            invoice: 1,
            direct_payment: 2,
            questionnaire: 3,
            brochure: 4,
            timeline: 5,
            agreement: 6
        },

        WorkspaceStatus: {
            lead: 0,
            lead_archived: 1,
            client: 2,
            client_archived: 3,
            lead_sent: 4
        },

        WorkspaceStageCategory: {
            none: "",
            lead: "lead",
            booked: "booked"

        },

        isAllowedBulkEmails: {
            maxProjectsPerBatchExceeded: 'isAllowedBulkEmails_maxProjectsPerBatchExceeded',
            gmailIntegraion: 'isAllowedBulkEmails_gmailIntegraion',
            premiumFeatureOnly: 'isAllowedBulkEmails_premiumFeatureOnly',
            maxDailyPassed: 'isAllowedBulkEmails_maxDailyPassed',
            runningTask: 'isAllowedBulkEmails_runningTask',
            notAllowed: 'isAllowedBulkEmails_notAllowed',
        },

        WorkspaceFileStatus: {
            0: '_NEW_WORKSPACE_CREATE_',
            1: '_WELCOME_EMAIL_SENT_',
            2: '_WELCOME_BROCHURE_SEEN_',
            3: '_QUESTIONNAIRE_SEEN_',
            4: '_QUESTIONNAIRE_ANSWER_',
            5: '_PROPOSAL_CREATED_',
            6: '_PROPOSAL_SENT_',
            7: '_PROPOSAL_BROCHURE_SEEN_',
            8: '_PROPOSAL_SEEN_',
            9: '_AGREEMENT_SEEN_',
            10: '_AGREEMENT_SIGNED_',
            11: '_PAYMENTS_SEEN_',
            12: '_RETAINER_PAID_',
            13: '_PAYMENT_DONE_'
        },

        ContractSigneeTypes: {
            couple_signature: 0,
            planner_signature: 1

        },

        QuestionnaireConnectedEventProperties: {
            eventType: 'event_type',
            eventLocation: 'event_location',
            eventDate: 'event_date',
            eventTime: 'event_time',
            eventGuests: 'event_guests',
            eventBudget: 'event_budget',
            eventDetails: 'event_description',
            event_type: 'Project Type',
            event_location: 'Project Location',
            event_date: 'Project Date',
            event_time: 'Project Time',
            event_guests: 'Project Guests',
            event_budget: 'Project Budget',
            event_details: 'Project Description',
            event_description: 'Project Description'
        },

        QuestionnaireConnectedObjects: {
            event: 'event'
        },

        QuestionnaireQuestionTypes: {
            textbox: 'textbox',
            openQuestion: 'open_question',
            dropdown: 'dropdown',
            radio: 'radio',
            checkbox: 'checkbox'
        },

        ContactFormDataKeys: {
            email: 'email',
            full_name: 'full_name',
            phone_number: 'phone_number',
            event_date: 'event_date',
            event_location: 'event_location',
            event_guests: 'event_guests',
            event_budget: 'event_budget',
            event_details: 'event_details',
            event_services: 'event_services',
            event_type: 'event_type',
            how_client_hear_about: 'how_client_hear_about',
            how_client_hear_about_company: 'how_client_hear_about_company'
        },

        FeedItemTypes: {
            workspace_email: 0,
            workspace_file_email: 1,
            workspace_message: 2,
            activity: 3,
            feed_message: 4,
            file_comment_message: 5,
            generic_message: 6,
            lead: 7,
            preferred_vendors_list: 8,
            reschedule_project_email: 13
        },

        WorkflowAutomationTypes: {
            reminder_event_coming_up: 0,
            reminder_unsent_file: 1,
            reminder_file_not_booked: 2,
            inquiry_reply_thank_you: 3,
            automation_send_questionnaire: 4,
            client_payment_reminder: 5,
            client_file_not_viewed: 6,
            reminder_file_sent_email_not_viewed: 7,
            default_file_expiration: 8,
            show_date_conflicts: 9,
            add_automated_emails_to_activity: 10,
            upcoming_payment_reminder: 11,
            outstanding_payment_reminder: 12,
            due_payment_reminder: 13,
            auto_recurring_payment_reminder: 14
        },

        EmailTypes: {
            proposal: 'proposal',
            invoice: 'invoice',
            payment_reminder: 'payment_reminder',
            request_proposal: 'request_proposal',
            questionnaire: 'questionnaire',
            widget: 'widget',
            brochure: 'brochure',
            inbound: 'inbound',
            timeline: 'timeline'
        },

        EmailTypesCd: {
            proposal: 0,
            invoice: 1,
            payment_reminder: 2,
            request_proposal: 3,
            questionnaire: 4,
            widget: 5,
            brochure: 6,
            inboud: 7,
            timeline: 8
        },

        SocialNetworkTypes: {
            facebook: 'facebook',
            instagram: 'instagram',
            twitter: 'twitter',
            linkedin: 'linkedin'
        },

        DraftInvalidation: {
            general: '_VENDOR_VERSION_INVALIDATED_1_',
            client_signed: '_VENDOR_VERSION_INVALIDATED_SIGNED_1_',
            client_paid: '_VENDOR_VERSION_INVALIDATED_PAID_1_',
            payment_reverted: '_VENDOR_VERSION_INVALIDATED_PAYMENT_REVERTED_1_',
            client_updated_agreement: '_VENDOR_VERSION_INVALIDATED_1_'
        },

        COORD_TYPE: {
            'X0': 0,
            'Y0': 1,
            'X1': 2,
            'Y1': 3,
            'W': 4,
            'H': 5
        },

        //TIP_TYPES = [:product, :analytics, :branding, :honeybook]
        HoneyTipsTypes: {
            product: 0,
            analytics: 1,
            branding: 2,
            honeybook: 3
        },

        contactFormErrorValidationTypes: {
            general: 'general',
            redirectUrl: 'redirectUrl',
        },

        contactFormSideBarMenuKeys: {
            settings: 'menu.options.settings',
            contactForms: 'menu.options.contactForms',
			giftCards: 'menu.options.giftCards',
            design: 'menu.options.design',
            fonts: 'menu.options.design.fonts',
            colors: 'menu.options.design.colors',
            options: 'menu.options'
        },

        ABTests: {
            humanOutreach: 'human_outreach',
            trialerSendMobileAppReminder: 'trialer_send_mobile_app_reminder', // DONE
            extendTrialByType: 'extend_trial_by_type',
            extendTrialByTypeV2: 'extend_trial_by_type_v2',
            onboardingInvoice:'onboarding_invoice', // DONE
            onBoardingFourPanels: 'onboarding_4_panels', //DONE
            referralAwarenessSubject: 'referral_awareness_subject',
            referralAwarenessContent: 'referral_awareness_dashboard',
            referralAwarenessLandingPage: 'referral_awareness_landingpage',
            onboardingBanner: 'onboarding_banner',
            referralAwarenessFinal: 'referral_awareness_final', //DONE
            paywallTempDiscount: 'paywall_temp_discount',
            extendTrialV4: 'extend_trial_v4', // DONE
            extendTrialV5: 'extend_trial_v5', // DONE (none)
            intakeFormAtws: 'intake_form_atws', // ['ctrl', 'home'], #Done: home
            communityPretrialerAdV2: 'community_pretrialer_ad_v2', //Done, deleted.
            atwsPretrialerAd: 'atws_pretrialer_ad', //DONE, deleted.
            onboardingSetupGuide: 'onboarding_setup_guide', //DONE true
            trialDuration: 'trial_duration',
            facebookTrialerDiscount: 'facebook_trialer_discount', // ['20', '50', 'free_months', 'dollar']
            referralNotifications: 'referral_notifications', // ['off', 'on'] #Done: on
            referringUserPayoutExtraCTA: 'referring_user_payout_extra_cta', // [false, true] #Done: true
            referralModalOneCTA: 'referral_modal_one_cta', //  ['facebook', 'copy'] # Done: 'facebook'
            referralDashboardV3: 'referral_dashboard_versions', // //DONE 'new'
            membership: 'membership', // ['page', 'modal'] // Done 'page'
            referralReminderSubject: 'referral_reminder_subject', // ['waiting', 'expiring'] # Done: both
            homePage: 'home_page', // ['false', 'true']
            homePage50: 'home_page_50', // ['false', 'true']
            inviteeEmailV3: 'invitee_Email_v3', // [['gift', 'avatar'] , DONE gift
            exampleProjectType: 'example_project_type', // ['client_bot', 'first_proposal'] Done: client_bot
            referralAchievements: 'user_referral_achievements', // DONE false
            extendTrialV6: 'extend_trial_v6', // ['plain', 'marketing'], # Done: remove email
            clientAccessibilityTopNav: 'client_accessibility_top_nav', // DONE true
            referralModalFbOrCopyAndFb: 'referral_modal_fb_or_copy_and_fb', // DONE  'copy_and_facebook'
            referralInWsBanner: 'referral_in_ws_banner', //['hide', 'show']
            setupGuideType: 'setup_guide_type', // ['setup_guide_page', 'setup_guide_modal'] #Done: 'setup_guide_modal'
            referralDashboardSuggestions: 'referral_dashboard_suggestions', // [true : false] #Done: true
            onboarding4panels: 'onboarding_4panels', // ['4panels', 'all-in-one', 'what-is-honeybook'] #Done: '4panels'
            atwsCleanUi: 'atws_clean_ui', // ['pipeline', 'clean'] #Done: 'pipeline'
            mwebQuizQuestion : 'mweb_quiz_question', // ['projects', 'revenue'] #DONE: 'revenue'
            onboarding4panelsOrQuiz: 'onboarding_4panels_or_quiz', //['4panels', 'quiz'] #DONE 'quiz'
            accountSetupPrompt: 'account_setup_prompt', //['promptForMaterials', 'promptForSubscription'] # Done: 'promptForSubscription'
            referralAwarenessEmailSender: 'referral_awareness_email_sender', //['steph', 'oz'] DONE Steph
            onboardingQuizQuestions: 'onboarding_quiz_questions', //['2', '4', '6'] DONE: 6
            membershipSetupOffer: 'membership_setup_offer', // ['original', 'setup'], # Done: 'original'
            homeType: 'home_type', // ['home_for_trialers', 'home_for_subscribers'], # Done: 'home_for_trialers'
            exTrialerOfferExtend: 'extrialer_offer_extend', // => ['subscribe', 'extend'] #Done 'subscribe
            editReferralEmail: 'edit_referral_email', // => ['false', 'true']
            onboardingContactFormTask: 'onboarding_contact_form_task', // => ['true', 'false'],
            onboardingSetupGuideStreamlined: 'onboarding_setup_guide_streamlined', // => ['original_dark', 'streamlined_dark'] #Done: 'streamlined_dark'
            onboardingQuizOrNothing: 'onboarding_quiz_or_nothing', // ['quiz', 'nothing'], Done: 'quiz'
            contractsLpsFlow: 'contracts_lps_flow', // ['setup_guide', 'templates']
            accountSetupInSetupGuide: 'account_setup_in_setup_guide',// ['get_help' ,'start_free', 'import_existing'] Done start_free
            canceledMembersReachout: 'canceled_members_reachout',// ['ctrl', 'email']
            onboardingNurtureEmailsYbV2: 'onboarding_nurture_emails_yb_v2', //['value_props', 'branding_first']. DONE, 'branding_first'
            onboardingQuizCriticalQuestions: 'onboarding_quiz_critical_questions', // ['critical', 'all'] # Done: (Moving to pureRomeyQuizCriticalQuestions)
            onboardingSetupGuideHome: 'onboarding_setup_guide_home', // [streamlined_dark, streamlined_home]
            accountSetupInSetupGuideFree: 'account_setup_in_setup_guide_free', // => ['get_help', 'start_free', 'import_existing'] # Done: 'import_existing'
            contactFormVersion: 'contact_form_version', //['simple_html', 'dynamic_file'] # Done: 'dynamic_file'
            sendFilePreview: 'send_file_preview', // [hide, show]. DONE show
            mwebLandingExperience: 'mweb_landing_experience', // ['setup_guide', 'home'] # Done: 'home'
            streamlinedInvoiceVsProposal: 'streamlined_invoice_vs_proposal', // ['proposal', 'invoice']
            mwebBlock: 'mweb_block', // ['unblocked', 'blocked']
            pureRomeyQuizCriticalQuestions: 'pure_romey_critical_quiz_questions', // ['critical', 'all'] # Done: (Moving to quiz3vs5Quetions)
            sendFilePreviewForMembers: 'send_file_preview_for_members', //['true', 'false'] # Done: true
            accountSetupPromptToAccountSetupPage: 'account_setup_prompt_to_account_setup_page',
            interactiveOnboarding: 'interactive_onboarding', // ['streamlined_home', 'interactive']
            interactiveAddProfileImage: 'interactive_add_profile_image', // ['control', 'switch', 'hide']
            paidDefault: 'paid_default', // ['annual', 'monthly'] Done apr 21
            pushMobileTrialerToDesktop2: 'push_mobile_trialer_to_desktop_email2',
            workflowPlacement: 'workflow_placement', // ['lower', 'upper']. Done: 'lower'
            quiz3vs5Quetions: 'quiz_3_vs_5', // ['3', '5']. Done: '3'
            templatesPageRedesign: 'templates_page_redesign', // ['true', 'false'] # Done: 'true'
            giftCardStartWithTemplate: 'gift_card_start_with_template',
            toolsCatalogRedesign: 'tools_catalog_redesign',

        },

        Campaigns: {
            paywall: 'fbpw'
        },

        PubSubTriggers: {
            companySubscribed: 'companySubscribed',
            startedTrial: 'startedTrial',
            extendedTrial: 'extendedTrial',
            gotPricingPlans: 'gotPricingPlans',
            firstPayableFileSent: 'firstPayableFileSent',
            autoFeedMessage: 'autoFeedMessage',
            openFeedEditor: 'openFeedEditor',
            membershipCanceled: 'membershipCanceled',
            companyChanged: 'companyChanged',
            companyBrandingUpdated: 'companyBrandingUpdated'
        },

        CompanyOwnerNotificationTypes: {
            0: 'COMPANY_SETTING.TEAM.NOTIFICATIONS._CLIENT_PAYS_',
            1: 'COMPANY_SETTING.TEAM.NOTIFICATIONS._CLIENT_SIGNS_'
        },

        ContactFormBuilderType: {
            questions: 'questions',
            buttons: 'buttons'
        },

        Tools: {
            statuses : {
                new: 'new',
                listed: 'listed',
                active: 'active'
            },

            categories : {
                productivity: 'productivity',
                essentials: 'essentials',
                finance: 'finance',
                leadCapture: 'leadCapture',
                community: 'community',
            },
        },

        workspaceTabTypes: {
            feed: 'feed',
            files: 'files',
            payments: 'payments'
        },

        AtwsStage: {
            beforeCreatingFirstEvent: 1,
            createdFirstEvent: 2,
            createdSecondEvent: 3
        },

        PaymentMethods: {
            bankAccount: 'bank_account',
            creditCard: 'credit_card'
        },

        adyenPaymentMethodTypes: {
            bank_account: 'ach',
            credit_card: 'scheme'
        },

        PaymentMethodTypes: {
            bankAccount: 'PaymentMethodStripeBankAccount',
            creditCard: 'PaymentMethodStripeCard',
            adyenCreditCard: 'PaymentMethodAdyenCard',
            adyenBankAccount: 'PaymentMethodAdyenBankAccount'
        },

        PaymentAmountTypes: {
            customAmount: 'fixedAmount',
            percentage: 'percentageAmount',
            divideEqually: 'divideEquallyAmount'
        },

        IntakeFormSource: {
            tools: 'tools',
            onboardingPanel: 'onboardingPanel',
            pipeline: 'pipeline',
            topNav: 'topNav',
            urlParam: 'urlParam',
            communityOpsAd: 'communityOpsAd',
            workspaceAd: 'workspaceAd',
            settings: 'settings'
        },

        IntakeFormVersion: {
            communityTools: 'communityTools', //NA
            communityTrial: 'communityTrial',
            communityOriginal: 'communityOriginal', //NA
            workflowOriginal: 'workflowOriginal', //NA
            workflowHome: 'workflowHome'
        },

        LandingPages: {
          smartBooking: 'smart-booking'
        },

        ExpenseCategories: {
            0: {label: 'Expenses',
                options: {
                    0: {id: 1, symbol:'accounting_fees', name: 'Accounting Fees'},
                    1: {id: 2,symbol:'advertising_marketing', name: 'Advertising/Marketing'},
                    2: {id: 3,symbol:'auto_insurance', name: 'Auto insurance'},
                    3: {id: 4,symbol:'auto_repairs', name: 'Auto repairs'},
                    4: {id: 5,symbol:'automobile_expense', name: 'Automobile expense'},
                    5: {id: 6,symbol:'bank_service_charges', name: 'Bank service charges'},
                    6: {id: 7,symbol:'casual_help', name: 'Casual help'},
                    7: {id: 8,symbol:'internet_expenses', name: 'Computer & internet expenses'},
                    8: {id: 9,symbol:'contractors', name: 'Contractors'},
                    9: {id: 10, symbol:'credit_card_interest',name: 'Credit card interest'},
                    10: {id: 11,symbol:'dues_subscriptions', name: 'Dues & subscriptions'},
                    11: {id: 12,symbol:'equipment_rental', name: 'Equipment rental'},
                    12: {id: 13,symbol:'gas', name: 'Gas & fuel'},
                    13: {id: 14,symbol:'graphic_design', name: 'Graphic design'},
                    14: {id: 15,symbol:'office_expenses', name: 'Home office expenses'},
                    15: {id: 16,symbol:'insurance', name: 'Insurance'},
                    16: {id: 17,symbol:'legal_fees', name: 'Legal fees'},
                    17: {id: 18,symbol:'licenses', name: 'Licenses & permits'},
                    18: {id: 19,symbol:'loan_interest', name: 'Loan interest'},
                    19: {id: 20,symbol:'entertainment', name: 'Meals & entertainment'},
                    20: {id: 21,symbol:'office_supplies', name: 'Office supplies'},
                    21: {id: 22,symbol:'other', name: 'Other'},
                    22: {id: 23,symbol:'parking', name: 'Parking & tolls'},
                    23: {id: 24,symbol:'delivery', name: 'Postage & delivery'},
                    24: {id: 25,symbol:'printing', name: 'Printing expenses'},
                    25: {id: 26,symbol:'professional_fees', name: 'Professional fees'},
                    26: {id: 27,symbol:'rent', name: 'Rent'},
                    27: {id: 28,symbol:'maintenance', name: 'Repairs & Maintenance'},
                    28: {id: 29,symbol:'salaries', name: 'Salaries & wages'},
                    29: {id: 30,symbol:'session_costs', name: 'Session costs'},
                    30: {id: 31,symbol:'small_equipment', name: 'Small equipment'},
                    31: {id: 32,symbol:'software', name: 'Software'},
                    32: {id: 33,symbol:'taxes', name: 'Taxes'},
                    33: {id: 34,symbol:'travel', name: 'Travel expenses'},
                    34: {id: 35,symbol:'utilities', name: 'Utilities'},
                    35: {id: 36,symbol:'website', name: 'Website expenses'}
                }
            },
            1: {label: 'Costs of Goods Sold',
                options: {
                    0: {
                        id: 37,
                        symbol:'costs_of_goods_sold',
                        name: 'Costs of Goods Sold'},
                    1: {
                        id: 38,
                        symbol:'materials_supplies',
                        name: 'Materials & Supplies'},
                    2: {
                        id: 39,
                        symbol:'merchant_fees',
                        name: 'Merchant Fees'},
                    3: {
                        id: 40,
                        symbol:'sales_commissions',
                        name: 'Sales Commissions'}
                }
            }
        },

        OpportunityDistributionTypes: {
            pinLocation: 'pin_location',
            anywhere: 'anywhere'
        },

        OpportunityStatusTypes: {
            active: 'active',
            enoughReplies: 'enough_replies',
            bookedFromCommunity: 'booked_from_community',
            bookedFromOther: 'booked_from_other',
            other: 'other'
        },

        CanadaInstitutionNumbers: {
            '830': "Airline Financial Credit Union Limited",
            '219': "Alberta Treasury Branches",
            '810': "All Trans Financial Services Credit Union Limited",
            '890': "Alliance des caisses populaires de l'Ontario Limitée",
            '842': "Alterna Savings and Credit Union",
            '303': "Amex Bank of Canada",
            '808': "Arnstein Community Credit Union Limited",
            '839': "Atlantic Central",
            '618': "B2B Bank (formerly B2B Trust)",
            '241': "Bank of America National Association",
            '177': "Bank of Canada",
            '308': "Bank of China (Canada)",
            '001': "Bank of Montreal",
            '245': "Bank of Tokyo-Mitsubishi UFJ (Canada)",
            '342': "Bank West",
            '360': "Barclay's Bank PLC Canada Branch",
            '250': "BNP Paribas (Canada)",
            '311': "BofA Canada Bank",
            '347': "Bridgewater Bank",
            '815': "La Caisse Centrale Desjardins Du Québec",
            '010': "Canadian Imperial Bank of Commerce",
            '338': "Canadian Tire Bank",
            '030': "Canadian Western Bank",
            '323': "Capital One Bank (Canada Branch)",
            '809': "Central 1 Credit Union British Columbia",
            '828': "Central 1 Credit Union Ontario",
            '548': "CIBC Trust Corporation",
            '260': "Citibank Canada",
            '328': "Citibank N.A.",
            '309': "Citizens Bank of Canada",
            '330': "Comerica Bank",
            '807': "Communication Technologies Credit Union Limited",
            '507': "Community Trust Company",
            '853': "Concentra Financial Services Association",
            '899': "Credit Union Central Alberta Limited",
            '879': "Credit Union Central of Manitoba Limited",
            '889': "Credit Union Central of Saskatchewan",
            '608': "CS Alterna Bank",
            '315': "CTC Bank of Canada",
            '265': "Deutsche Bank AG",
            '352': "DirectCash Bank",
            '840': "Dundalk District Credit Union Limited",
            '343': "Dundee Bank of Canada",
            '532': "Effort Trust Company",
            '345': "Fifth Third Bank",
            '332': "First Commercial Bank",
            '310': "First Nations Bank of Canada",
            '865': "La Fédération des caisses populaires Acadiennes Limitée",
            '829': "La Fédération des caisses populaires de l'Ontario Inc.",
            '819': "La Fédération des caisses populaires du Manitoba Inc.",
            '344': "General Bank of Canada",
            '844': "Goderich Community Credit Union Limited",
            '854': "Golden Horseshoe Credit Union Limited",
            '321': "Habib Canadian Bank",
            '358': "HomEquity Bank",
            '630': "Household Trust Company",
            '016': "HSBC Bank Canada",
            '333': "HSBC Bank USA National Association",
            '604': "HSBC Mortgage Corporation (Canada)",
            '340': "ICICI Bank Canada",
            '625': "Industrial Alliance Trust Inc.",
            '307': "Industrial and Commercial Bank of China (Canada)",
            '614': "ING Bank of Canada",
            '536': "Investors Group Trust Co. Ltd.",
            '314': "J.P. Morgan Bank Canada",
            '354': "Jameson Bank",
            '270': "JPMorgan Chase Bank National Association",
            '275': "Korea Exchange Bank of Canada",
            '803': "Latvian Credit Union Limited",
            '039': "Laurentian Bank of Canada",
            '522': "Laurentian Trust of Canada Inc.",
            '357': "M&T Bank",
            '540': "Manulife Bank of Canada",
            '626': "Manulife Trust Company",
            '336': "Maple Bank",
            '269': "Mega International Commercial Bank (Canada)",
            '837': "Meridian Credit Union",
            '277': "Mizuho Corporate Bank Ltd. Canada Branch",
            '361': "MonCana Bank of Canada",
            '550': "Montreal Trust Company of Canada",
            '006': "National Bank of Canada",
            '590': "National Trust Company",
            '846': "Ontario Civil Service Credit Union Limited",
            '334': "Pacific & Western Bank of Canada",
            '568': "Peace Hills Trust Company",
            '621': "Peoples Trust Company",
            '322': "Rabobank Nederland",
            '620': "ResMor Trust Company",
            '592': "Royal Bank Mortgage Corporation",
            '003': "Royal Bank of Canada",
            '240': "Royal Bank of Scotland N.V. (Canada) Branch",
            '570': "Royal Trust Company",
            '580': "Royal Trust Corporation of Canada",
            '606': "Scotia Mortgage Corporation",
            '355': "Shinhan Bank Canada",
            '292': "Société Générale (Canada Branch)",
            '346': "Société Générale (Canada Branch) Ontario",
            '294': "State Bank of India (Canada) Alberta",
            '327': "State Street",
            '301': "Sumitomo Mitsui Banking Corporation of Canada",
            '551': "Sun Life Financial Trust Inc.",
            '597': "TD Mortgage Corporation",
            '603': "TD Pacific Mortgage Corporation",
            '242': "The Bank of New York Mellon",
            '002': "The Bank of Nova Scotia",
            '509': "The Canada Trust Company",
            '623': "The Equitable Trust Company",
            '349': "The Northern Trust Company Canada Branch",
            '004': "The Toronto-Dominion Bank",
            '318': "U.S. Bank National Association",
            '339': "UBS AG Canada Branch",
            '290': "UBS Bank (Canada)",
            '335': "United Overseas Bank Limited",
            '359': "Walmart Canada Bank"
        },

        OpportunityTypes: {
            paid_opportunity: 'paid opportunity',
            collaboration: 'collaboration',
            offer_services: 'services offered',
            other: 'opportunity'
        },

        UserStatus: {
            activated: 'ACTIVATED',
            trial: 'TRIAL',
            preTrialer: 'PRE-TRIALER',
            trialExpired: 'EXPIRED_TRIAL'
        },

        AutoPaymentStatus: {
            inactive: 'inactive',
            pendingApproval: 'pending_approval',
            active: 'active'
        },

        ExtendedCreativeTypes: ExtendedCreativeTypes,
        SupportedCreativeTypes: ExtendedCreativeTypes.filter(function (t) {return t.supported;}),
        ExtendedCreativeTypesTranslationMap: mapEnumArrayToObject(ExtendedCreativeTypes, 'key', 'translationEntry'),

        ExtendedCreativeTypesPlural: ExtendedCreativeTypesPlural,

        HBDisputeStatus: {
            collecting_information: 'In Contact - Collecting Information',
            ready_to_submit:        'Ready to Submit ',
            forter_insured:         'Forter Insured',
            submitted:              'Submitted',
            won:                    'Won',
            lost_bad_vendor:        'Lost - Bad Vendor',
            lost_for_good:          'Lost - For Good',
            lost_lost:              'Lost - Lost',
            lost_accepted:          'Lost - Accepted',
            lost_to_recover:        'Lost - To Recover',
            lost_recovered:         'Lost - Recovered',
            lost_fraud:             'Lost - Fraud',
            lost_hb_subscription:   'Lost - HB Subscription',
            lost_hb_refund:         'Lost - HB Refund'
        },

        HBRecollectionStatus: {
            invoice_sent: 'Invoice sent',
            invoice_paid: 'Invoice paid',
            payouts_disabled: 'Payouts disabled (payout verification needed)',
            auto_reverse_from_bank: 'Bank debit pending',
            auto_reverse_from_bank_failed: 'Bank debit failed',
            auto_reverse_from_bank_success: 'Bank debit successful',
            pending_future_payments: 'Pending future payments',
            debit_failed_pending_future_payments: 'Debit failed. Pending future payments',
            partial_reserve_future_payments: 'Future funds partially recovered',
            full_reserve_future_payments: 'Future funds fully recovered',
            reserved_and_pushed_back: 'Vendor Won (reserved and pushed back)',
            manual_stop_recollect: 'Recollection was manually cancelled',
            manual_full_recollect: 'Marked as manually recollected'
        },

        CreateOpportunityOptionalSources: {
            main: 'main',
            secondary: 'secondary',
            empty_state: 'empty_state',
            popup_banner_after_user_interaction: 'popup_banner_after_user_interaction',
            edit: 'edit'
        },

        DisputeStatuses: {
            '': 'All',
            lost: "Lost",
            won: "Won",
            warning_closed: "Warning Closed",
            under_review: "Under Review",
            needs_response: "Needs Response",
            warning_needs_response: "Warning Needs Response",
            warning_under_review: "Warning Needs Response",
            partially_won: "Partially Won",
            chargeback: "Chargeback",
            chargeback_reversed: "Chargeback Reversed",
            notification_of_chargeback: "Notification of Chargeback",
            notification_of_fraud: "Notification of Fraud",
            prearbitration_lost: "Prearbitration Lost",
            prearbitration_won: "Prearbitration Won",
            request_for_information: "Request for Information",
            second_chargeback: "Second Chargeback"
        },

        pricingPlanTypes: {
            annual: 'annual',
            monthly: 'monthly',
            lifetime: 'lifetime',
            free: 'free',
            manual: 'manual'
        },

        timeTrackerSource: {
            tool: 'tool',
            all_entries_modal: 'all_entries_modal',
            workspace: 'workspace'
        },
        timeTrackerFilters: {
            allTime: 'all_time',
            last30Days: 'last_30_days',
            last90Days: 'last_90_days',
            customRange: 'custom_range',
        },

        taxTypes: {
            'relative': 'relative',
            'absolute': 'absolute'
        },

        discountTypes: {
            'relative': 'relative',
            'absolute': 'absolute'
        },

        createFileOriginType: {
            blank: 'blank',
            file: 'file',
            template: 'template'
        },

        badgePillTypes: {
            lead_sources: 'lead_source',
            project_types: 'project_type',
            company_spaces: 'company_spaces'
        },

        homeRecentActivityTypes: {
            contract_signed: 'contract_signed',
            feed_message: 'feed_message'
        },

        createNew: {
            invoice : "invoice",
            project: "project",
            client: "client",
            meeting: "meeting"
        },

        fileBuilderBlockTypes: {
            content: 'content',
            questions: 'questions',
            proposal: 'proposal'
        },

        fileBuilderContentTypes: {
            text: 'text',// 'full_width_text',
            image: 'image',// 'cover_image',
            two_column_text: 'two_column_text',// 'two_column_text',
            two_column_images: 'two_column_images',// 'two_images',
            text_over_image: 'text_over_image',// 'text_on_image',
            text_and_image: 'text_and_image',// 'left_aligned'
            component: 'component',
        },

        questionsCategories: {
            suggested: 'suggested',
            custom: 'custom',
        },

        customQuestions: {
            short_text: 'open_question',
            long_text: 'textarea',
            drop_down: 'dropdown',
            two_fields: 'two_fields',
            single_choice: 'radio',
            multiple_choice: 'checkbox',
            date_picker: 'date_picker',
            file_upload: 'file_upload',
            picture_choice: 'picture_choice'
        },

        suggestedQuestions: {
            full_name: 'full_name',
            email: 'email',
            phone_number: 'phone_number',
            about: 'event_details',
            lead_source: 'lead_source',
            project_type: 'event_type',
            project_location: 'event_location',
            project_budget: 'budget',
            project_date: 'project_date',
            guests: 'event_guests',
        },

        setsQuestions: {
            sets: 'sets',
            basic: 'basic',
            project_details: 'project_details',
            company_type: 'company_type',
            project_type: 'project_type',
            project_date: 'project_date',
            project_location: 'project_location',
            project_budget: 'project_budget',
            project_guest_count: 'project_guest_count',

        },

        // IMPORTANT: values lower case only.
        doodles: {
            winter: 'winter',
            pride: 'pride',
            july4th: '4th-july',
            usaFlag: 'usa-flag',
            thanksgiving: 'thanksgiving',
            blackLivesMatter: 'black-lives-matter',
            prideBlm: 'pride-blm'
        },

        proposalSelectionType: {
            noSelect: 'no_select',
            selectOne: 'select_one',
            selectOneRequired: 'select_one_required',
            selectMultiple: 'select_multiple',
            selectMultipleRequired: 'select_multiple_required'
        },

        calendarTypes: {
            payments: 'payments',
            tentativeProjects: 'tentativeProjects',
            team: 'team'
        },

        contactFormMembers: {
            recipient: { key: 'recipient', seniorityScore: 0, translationEntry: 'CONTACT_FORM.MEMBERS.ROLES._LEADS_RECIPIENT_', subtextTranslationEntry: 'CONTACT_FORM.MEMBERS.ROLES._LEADS_RECIPIENT_SUBTEXT_' },
            workspace_member: { key: 'workspace_member', seniorityScore: 1, translationEntry: 'CONTACT_FORM.MEMBERS.ROLES._WORKSPACE_PARTICIPANT_', subtextTranslationEntry: 'CONTACT_FORM.MEMBERS.ROLES._WORKSPACE_PARTICIPANT_SUBTEXT_' },
            owner: { icon: 'https://res.cloudinary.com/honeybook/image/upload/v1565595775/app/ui/crown.svg', key: 'owner', seniorityScore: 2, translationEntry: 'CONTACT_FORM.MEMBERS.ROLES._OWNER_', subtextTranslationEntry: 'CONTACT_FORM.MEMBERS.ROLES._OWNER_SUBTEXT_' },
        },

        pipelineActionsPopoverTypes: {
            stage: 'stage',
            archive: 'archive'
        },

        onboardingSteps: {
            account: 'account',
            branding: 'branding',
            services: 'services',
            clientSide: 'client_side',
            subscribe: 'subscribe',
            templates: 'templates',
            createProject: 'create_project',
            contactForm: 'contact_form',
            bankInfo: 'bank_info',
            accountSetup: 'account_setup'
        },

        calendarPopoverTypes: {
            google_event: 'google_event',
            hb_meeting: 'hb_meeting',
            lead_project: 'lead_project',
            booked_project: 'booked_project',
            payment: 'payment',
            day_click: 'day_click',
            event_limit: 'event_limit',
            team_project: 'team_project',
            team_meeting: 'team_meeting'
        },

        leadsInsightsStates: {
            locked: 'locked',
            collecting: 'collecting',
            results: 'results'
        },

        sessionType: {
            phoneCall: 'phone_call',
            inPerson: 'in_person',
            videoCall: 'video_call'
        },

        sessionWindowType: {
            indefinitely: 'indefinitely',
            fixedDateRange: 'fixed_date_range',
            rollingWindow: 'rolling_window'
        },

        giftCardStates: {
            promotionPurchased: 'promotion_purchased',
            voucherRedeemed: 'voucher_redeemed'
        },

        paymentGateways: {
            Stripe: 'stripe',
            Adyen: 'adyen'
        }
    };
};
